import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Divider from '@components/Divider';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import PointHeader from './components/PointHeader';
import PointLogs from './components/PointLogs';

declare module '@stackflow/config' {
    interface Register {
        PointActivity: {};
    }
}

const PointActivity: ActivityComponentType<'PointActivity'> = () => {
    const { t } = useTranslation('point');
    return (
        <AppScreen>
            <Column fullWidth>
                <Header title={t('title')}/>
                <PointHeader/>
                <PointLogs/>
                <Divider/>
                <Accordion title={t('notice.title')}/>
            </Column>
        </AppScreen>
    );
};

export default PointActivity;
